// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","PaginationWrapper":"_2rNqE5","Pagination":"_3eHnjZ","PaginationContent":"e5rx7n","fadeInFrames":"_1fbZ8x"};